import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import Helmet from 'react-helmet';

import useDismissiblePersistent from '../../../hooks/useDismissiblePersistent';
import { WG_BOTTOM_APP_DOWNLOAD_BANNER } from '../../../constants/dismissibleKeys';
import { shouldDisplayAppDownloadBanner } from '../../../components/global/AppDownloadBanner/helpers';
import { ALBUM_TYPE } from '../../../constants/albums';
import AppDownloadBanner from '../../../components/global/AppDownloadBanner';

const propTypes = {
  route: PropTypes.object,
};

const ShutterbugMasterView = ({ route }) => {
  const { onDismiss, visible } = useDismissiblePersistent(
    WG_BOTTOM_APP_DOWNLOAD_BANNER,
  );
  const shouldDisplayAppDownloadBannerBool = shouldDisplayAppDownloadBanner({
    album_type: ALBUM_TYPE.SHUTTERBUG,
  });

  return (
    <Fragment>
      <Helmet>
        <title>Waldo</title>
      </Helmet>
      {renderRoutes(route.routes)}
      {visible && shouldDisplayAppDownloadBannerBool && (
        <AppDownloadBanner onDismiss={onDismiss} />
      )}
    </Fragment>
  );
};

ShutterbugMasterView.propTypes = propTypes;

export default ShutterbugMasterView;
